import { Pipe, PipeTransform } from '@angular/core';
import { TransportTypeUtils } from '../ui/util/transportType.Utils';
import { AuthGateway } from '../application/gateway/AuthGateway';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'transportName'
})
export class TransportNamePipe implements PipeTransform {

    constructor(private _authService: AuthGateway,
      public translate: TranslateService, ) {}

  transform(transportType: number): string {
    let pageLang = this.translate.currentLang

    const profile = this._authService.getUser()
    if(profile) pageLang = profile.lang

    return TransportTypeUtils.getTransportName(pageLang, transportType);
  }

}
